/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  visit: VisitDtoModelType;
}

/**
 * OrderCompletedDtoBase
 * auto generated base class for the model OrderCompletedDtoModel.
 */
export const OrderCompletedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('OrderCompletedDto')
  .props({
    __typename: types.optional(types.literal("OrderCompletedDto"), "OrderCompletedDto"),
    /** Order has been finished/missed */
    visit: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => VisitDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class OrderCompletedDtoModelSelector extends QueryBuilder {
  visit(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`visit`, VisitDtoModelSelector, builder) }
}
export function selectFromOrderCompletedDto() {
  return new OrderCompletedDtoModelSelector()
}

export const orderCompletedDtoModelPrimitives = selectFromOrderCompletedDto()
